import { Box } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import SearchInput from "./SearchInput";

const AnimatedSearchContainer = styled(Box, {
  shouldForwardProp: prop => prop !== "expanded"
})(({ expanded, theme }) => ({
  position: "relative",
  width: "100%",
  height: "60px",
  maxWidth: "700px",
  margin: "0 auto",
  zIndex: 10,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  transition: "none"
}));

const SearchContainer = ({
  expanded,
  currentStep,
  searchData,
  fieldErrors,
  placeholder,
  startAdornment,
  isValid,
  isMobile,
  inputRef,
  value,
  onChange,
  onKeyDown,
  onButtonClick,
  onFocus,
  onBlur,
  disabled,
  isLoading = false,
  hideButton = false,
  isListening = false,
  speechSupported = false,
  onVoiceSearch
}) => {
  const theme = useTheme();

  return (
    <AnimatedSearchContainer expanded={expanded}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Always row for search container
          gap: 1,
          alignItems: "center",
          position: "relative",
          width: "100%",
          transition: "gap 100ms ease",
          justifyContent: "center"
        }}
      >
        <Box
          sx={{
            flex: 1,
            width: "100%"
          }}
        >
          <SearchInput
            ref={inputRef}
            expanded={expanded}
            currentStep={currentStep}
            searchData={searchData}
            fieldErrors={fieldErrors}
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            startAdornment={startAdornment}
            value={value}
            isMobile={isMobile}
            onSubmit={onButtonClick}
            submitDisabled={disabled}
            isLoading={isLoading}
            isListening={isListening}
            speechSupported={speechSupported}
            onVoiceSearch={onVoiceSearch}
          />
        </Box>
      </Box>
    </AnimatedSearchContainer>
  );
};

export default SearchContainer;
